export default __webpack_public_path__ + "static/Ransomware-Kill-Switch-2023-023c0f42a2bd75fe0ec54c5946a91914.pdf";